import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { learningCycle } from '@/mocks/curriculumData';

const STEP_COUNT = 4;

export default function LearningCycle() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('curriculum.cycle.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('curriculum.cycle.title')}
          </h2>
          {String(t('curriculum.cycle.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('curriculum.cycle.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        {/* Flow Diagram */}
        <div className="relative">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-16 left-[10%] right-[10%] h-[1px] bg-accent-500/20 z-0"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {Array.from({ length: STEP_COUNT }, (_, idx) => (
              <div key={idx} className="relative z-10 flex flex-col items-center text-center group">
                {/* Step Number + Icon */}
                <div className="relative mb-5">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-900 text-accent-400 group-hover:bg-accent-500 group-hover:text-primary-900 transition-all duration-500">
                    <i className={`${learningCycle.steps[idx].icon} text-2xl`}></i>
                  </div>
                  {idx < STEP_COUNT - 1 && (
                    <div className="hidden lg:flex absolute top-1/2 -right-3 w-6 h-4 items-center justify-center text-accent-500/30">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </div>
                  )}
                </div>

                {/* Step Number */}
                <p className="text-accent-500 text-[12px] tracking-[0.15em] font-medium mb-2">
                  STEP {t(`curriculum.cycle.${idx}.step`)}
                </p>

                {/* Title */}
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1 group-hover:text-accent-600 transition-colors">
                  {t(`curriculum.cycle.${idx}.title`)}
                </h3>
                <p className="text-[12px] text-accent-500/70 tracking-[0.1em] mb-3">
                  {t(`curriculum.cycle.${idx}.titleEn`)}
                </p>

                {/* Description */}
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {t(`curriculum.cycle.${idx}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Note about progression */}
        <div className="mt-14 text-center">
          <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('curriculum.cycle.note')}
            <Link to="/courses" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors ml-1">
              {t('curriculum.cycle.coursesLink')}
            </Link>
            {/* period after link — handled by CSS or kept empty */}
          </p>
        </div>
      </div>
    </section>
  );
}
